import React from 'react';
import Modal from 'react-bootstrap/Modal';

import AsyncSelect from "react-select/async";
import { reactSelectIcons } from "../../util/reactSelectPrimeIcons";
import { asyncSelectCustomStyles } from "../../util/styles";

import './Style.css';

class ModalAvaliacao extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            motivosSelecionados: [],
            form: {
                id: null,
                base_id: props.baseId || '',
                motivos: [],
                comentario: null,
            },
            loadingData: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.open && !prevProps.open) {
            this.initializeModal();
        }
    }

    initializeModal = async () => {
        const {
            evaluationId,
            baseId,
            initialMotivos,
        } = this.props;

        if (evaluationId) {
            await this.loadEvaluation(evaluationId);
            return;
        }

        const motivos = initialMotivos || [];

        this.setState({
            loadingData: false,
            motivosSelecionados: motivos,
            form: {
                id: null,
                base_id: baseId || '',
                motivos: motivos,
                comentario: '',
            },
        });
    };

    loadEvaluation = async (id) => {
        this.setState({
            loadingData: true,
        });

        try {
            const response = await axios.get(
                `/visualizar-avaliacao/${id}`
            );

            const evaluation = response.data;
            const motivosMap = new Map();

            (evaluation.criteria || []).forEach((criterion) => {
                const weight = criterion.evaluation_weigth;

                if (!weight) {
                    return;
                }

                if (!motivosMap.has(weight.id)) {
                    motivosMap.set(weight.id, {
                        id: weight.id,
                        text: `${weight.reason} / ${weight.criterion}`,
                        evaluation_weight_id: criterion.evaluation_weigth_id,
                        evaluation_rule_id: criterion.evaluation_rule_id,
                        conditional_id: criterion.condicional_id,
                    });
                }
            });

            const motivos = Array.from(
                motivosMap.values()
            );

            this.setState({
                form: {
                    id: evaluation.id || null,
                    base_id: evaluation.base_id || '',
                    motivos,
                    comentario: evaluation.comentario || '',
                },
                motivosSelecionados: motivos,
                loadingData: false,
            });
        } catch (error) {
            console.error('Erro ao carregar avaliação:', error);

            this.setState({
                loadingData: false,
            });
        }
    };

    resetForm = () => {
        this.setState({
            motivosSelecionados: [],
            form: {
                id: null,
                base_id: '',
                motivos: [],
                comentario: '',
            },
            loadingData: false,
        });
    };

    searchMotivos = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) {
            return [];
        }

        try {
            const response = await axios.get(
                `/autocomplete-motivos`,
                {
                    params: {
                        search: inputValue,
                        tipo: 'Avaliação',
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Erro ao buscar motivos:', error);
            return [];
        }
    };

    handleMotivosChange = (selectedOptions) => {
        const motivos = selectedOptions || [];

        this.setState((previousState) => ({
            motivosSelecionados: motivos,

            form: {
                ...previousState.form,
                motivos,
            },
        }));
    };

    handleInputChange = (event) => {
        const {
            name,
            value,
        } = event.target;

        this.setState((previousState) => ({
            form: {
                ...previousState.form,
                [name]: value,
            },
        }));
    };

    handleSubmit = async (event) => {
        event.preventDefault();

        const {
            form,
        } = this.state;

        if (!form.motivos || form.motivos.length === 0) {
            alert('Selecione ao menos um motivo antes de continuar!');
            return;
        }

        const data = {
            ...form,
            id: form.id || null,
            base_id: form.base_id || this.props.onSelectedBaseToValidate,
        };

        await this.props.onSubmit(data);
    };

    handleClose = () => {
        const {
            loading,
        } = this.props;

        const {
            loadingData,
        } = this.state;

        if (loading || loadingData) {
            return;
        }

        this.resetForm();

        this.props.onClose();
    };

    render() {
        const {
            open,
            loading,
            evaluationId,
        } = this.props;

        const {
            form,
            loadingData,
        } = this.state;

        const isEdit = !!evaluationId;

        return (
            <div style={{ zIndex: '9999' }}>
                <Modal
                    show={open}
                    onHide={this.handleClose}
                    dialogClassName="modal-avaliacao"
                    size="lg"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {isEdit ? 'Editar Avaliação' : 'Nova Avaliação'}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        {loadingData ? (
                            <div className="text-center">
                                <i className="fa fa-spinner fa-spin"></i>{' '}
                                Carregando avaliação...
                            </div>
                        ) : (
                            <form
                                className="form-modal"
                                onSubmit={this.handleSubmit}
                            >
                                <div className="formulario">

                                    <div className="form-group">
                                        <label>Motivo / Critério</label>

                                        <AsyncSelect
                                            isMulti
                                            closeMenuOnSelect={false}
                                            value={form.motivos}
                                            loadOptions={this.searchMotivos}
                                            getOptionLabel={(option) => option.text}
                                            getOptionValue={(option) => String(option.id)}
                                            onChange={this.handleMotivosChange}
                                            styles={asyncSelectCustomStyles}
                                            placeholder="Selecione"
                                            components={reactSelectIcons}
                                            noOptionsMessage={() => 'Digite para buscar...'}
                                            loadingMessage={() => 'Carregando...'}
                                            className="autocomplete"
                                            isDisabled={loading || loadingData}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Comentário</label>

                                        <textarea
                                            className=""
                                            placeholder="Digite"
                                            rows="1"
                                            cols="3"
                                            name="comentario"
                                            value={form.comentario || ''}
                                            onChange={this.handleInputChange}
                                            disabled={loading || loadingData}
                                        />
                                    </div>

                                    <div className="form-buttons">
                                        <button
                                            type="submit"
                                            className="btn btn-success btn-round background-brain"
                                            disabled={loading || loadingData}
                                        >
                                            {loading ? (
                                                <>
                                                    <i className="fa fa-spinner fa-spin"></i>{' '}
                                                    Processando...
                                                </>
                                            ) : (
                                                isEdit ? 'Atualizar' : 'Salvar'
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        )}

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default ModalAvaliacao;